import { useState } from 'react';

const useFlag = (defaultValue?: boolean) => {
  const [value, setValue] = useState(defaultValue ?? false);
  const toggle = () => {
    setValue(value => !value);
  };
  const setTrue = () => setValue(true);
  const setFalse = () => setValue(false);

  return { value, setFalse, setTrue, toggle };
};

export default useFlag;
